import { useRef, useState } from 'react'

const useSlideGesture = ({ containerRef }) => {
  const isDraggingRef = useRef(false)
  const startX = useRef(0)
  const scrollLeft = useRef(0)
  const [isDragging, setIsDragging] = useState(false)

  const handleMouseDown = (e) => {
    isDraggingRef.current = true
    setIsDragging(true)
    startX.current = e.pageX - containerRef.current.offsetLeft
    scrollLeft.current = containerRef.current.scrollLeft
  }

  const handleMouseUp = () => {
    isDraggingRef.current = false
    setIsDragging(false)
  }

  const handleMouseLeave = () => {
    isDraggingRef.current = false
    setIsDragging(false)
  }

  const handleMouseMove = (e) => {
    if (!isDraggingRef.current) return
    e.preventDefault()
    const base = e.pageX - containerRef.current.offsetLeft
    const walk = base - startX.current
    containerRef.current.scrollLeft = scrollLeft.current - walk
  }

  return {
    isDragging,
    onMouseUp: handleMouseUp,
    onMouseDown: handleMouseDown,
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave
  }
}

export default useSlideGesture
